import React from "react";
import { FooterContainer } from "../style/StyleComponentHeaderAndNav";
import { useNavigate } from "react-router-dom";
import { PROCESS_MANUAL_URL } from "../Variable";

const Footer: React.FC = () => {
    const navigate = useNavigate();

    const handleDownload = () => {
        const url = PROCESS_MANUAL_URL;
      
        const newWindow = window.open(url, '_blank');
        
        if (newWindow) {
          newWindow.focus();
        }
      };

    return (
        <FooterContainer className="" style={{backgroundColor : "white", marginTop : "20px"}}>
            <div className="hidden 2xl:block fake-box mt-[-20px]"></div>
            <div className="real-box">
                <div className="button-area">
                    <button>회사소개</button> &nbsp;|&nbsp;
                    <button
                        className="font-semibold"
                        onClick={() => navigate("/privacy_policy")}
                    >
                        개인정보처리방침
                    </button> &nbsp;|&nbsp;
                    <button
                        onClick={() => navigate("/terms_of_service")}
                    >
                        이용약관
                    </button> &nbsp;|&nbsp;
                    <button
                        onClick={handleDownload}
                    >
                        시공 프로세스 메뉴얼
                    </button>
                </div>
                <div className="corp-info-box">
                    <p>대표이사 : 김대웅 | 주소 : 부산광역시 해운대구 해운대로 598, CW 마린빌딩 7층</p>
                    <p>| 대표번호 : 051-558-1317 | 팩스 : 051-558-3579 | E-mail : ambience1mt@gmail.com</p>
                </div>
                <div className="copyright-box">
                    <p>COPYRIGHT(C) Ambience Corp. ALL RIGHT RESERVED.</p>
                </div>
            </div>
        </FooterContainer>
    )
};

export default Footer;
